import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router-dom';

import { Layout } from 'antd';

import ForgotPasswordForm from './ForgotPasswordForm';
import './ForgotPassword.css';

@inject('authStore')
@observer
class ForgotPassword extends Component {
  render() {
    const { authStore } = this.props;
    if (!authStore.isLoggedIn) {
      return (
        <Layout className="ForgotPasswordLayout">
          <Layout.Content className="ForgotPasswordLayoutContent">
            <ForgotPasswordForm />
          </Layout.Content>
        </Layout>
      );
    } else {
      return <Redirect to="/" />;
    }
  }
}

export default ForgotPassword;
